import * as Modal from './modal'

export default Modal
